// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__QZl1m","paramInput":"JobSimulator_paramInput__b96yh","input":"JobSimulator_input__1jkQv"};